import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SignalSearchIntervalService {
  interval: any;

  startInterval = (callback: () => void, ms: number) => {
    this.interval = setInterval(callback, ms);
  };

  stopInterval = () => {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  };

  clear() {
    this.stopInterval();
  }
}
